import { Fragment, ReactNode } from "react"
import styled from '@emotion/styled'
import { ApptListEndHour, apptListGridline, ApptListHourSpacingUnits, ApptListStartHour } from "./ApptList"

const V2L2ApptListTimelineRoot = styled.div({
	padding: '1rem',
	overflowX: 'hidden',
	overflowY: 'auto',
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr',
	// gridTemplateRows: `repeat(4, ${theme.spacing(HOUR_SPACING_UNITS)})`,
	gridAutoRows: `${ApptListHourSpacingUnits/2}rem`,
	columnGap: '.5rem',
})

const TimelineHourLabel = styled.div<{gridRow: string}>(({theme, gridRow}) => ({
	color: theme.colors.miniHeader,
	textAlign: 'right',
	fontSize: '14px',
	gridColumn: '1/2',
	gridRow,
}))

const TimelineHourSpace = styled.div<{gridRow: string}>(({gridRow}) => ({
	gridColumn: '2/-1',
	gridRow,
}))

const TimelineHourSpaceLine = styled.div(({theme}) => ({
	marginTop: theme.spacing(1),
	height: '1px',
	backgroundColor: theme.colors.lines,
}))

interface V2L2ApptListTimelineProps {
	children?: ReactNode
}

export const V2L2ApptListTimeline = ({children}: V2L2ApptListTimelineProps) => {
	const hours = []
	for(let h = ApptListStartHour; h <= ApptListEndHour; h++) {
		// let h12 = h
		// let meridian = 'AM'
		// if(h > 12) {
		// 	h12 = h - 12
		// }
		hours.push({
			h,
			gridRow: `${apptListGridline(h)}/${apptListGridline(h)+1}`
		})
		continue
	}
	return (
		<V2L2ApptListTimelineRoot>
			{hours.map(({h, gridRow}) => (
				<Fragment key={h}>
					<TimelineHourLabel gridRow={gridRow}>{h}:00</TimelineHourLabel>
					<TimelineHourSpace gridRow={gridRow}>
						<TimelineHourSpaceLine />
					</TimelineHourSpace>
				</Fragment>
			))}
			{children}
		</V2L2ApptListTimelineRoot>
	)
}
